import { Component, OnInit } from '@angular/core';
import { CmsService } from '../../core/services/cms.service';
import { StaticContentService } from '../static-content/static-content.service';
import { AppCacheService } from '../../core/services/cache/app-cache.service';
import { BUID, CacheConstant, CacheDuration, CMSPages, CMSTemplateNames } from '../../../app/core/constants/app.constant';
import * as _ from 'lodash';
import { CmsContent } from './../../shared/models/cms';
import { BaseComponent } from '../../../app/app.base.component';
import { DeviceDetectorService } from 'ngx-device-detector';
import { AppConfigService } from '../../../app/core/services/init/app-config.service';
import { Router } from '@angular/router';
 
 
 
 
@Component({
    selector: 'par-about-us',
    templateUrl: './about-us.component.html',
    styleUrls: ['./about-us.component.scss']
})
export class AboutUsComponent extends BaseComponent  implements OnInit {

  cmsPageName: any;
  templateNum: any;
  sequenceNum: any
  sequenceNo: number;
   envProperties =  this.cache.get(CacheConstant.Env_Properties);
   isAuthenticated:boolean = false;
  buId = this.envProperties.buId;
   
  aboutUsContent: any[] = [];
  aboutIntro: any[] = [];
  aboutCommercial:any[] = [];
  aboutConsumer: any[] = [];
  aboutConsumerImages: any[] = [];
  aboutConsumerTitle: any[] = [];
 
 /***************Constructor***************/
  constructor(
    private cmsService: CmsService,
    private router: Router,
    private staticContentService: StaticContentService,
    private cache: AppCacheService,
    deviceDetectorService: DeviceDetectorService,
    private appConfig: AppConfigService,
  ) { 
      super(deviceDetectorService, cache, appConfig);
  }

  ngOnInit(){
     this.getAboutUsData();
  }

 
  getAboutUsData(): void {
     if (this.isMobileDevice() && this.websiteName == 'Major') {
        this.cmsPageName = this.isAuthenticated ? CMSPages.Mobile_Home : CMSPages.Mobile_Login;
    }
     else
        this.cmsPageName = this.isAuthenticated ? CMSPages.Home : CMSPages.Login;
        this.templateNum = this.envProperties.cmsPageConfigVO.staticPageTemplateId;
        let sequenceNum =  this.envProperties.cmsPageConfigVO.aboutUsSeqNo;
        this.cmsService.getCmsStaticPageTemplateByPageNameAndTemplateNum(this.cmsPageName, this.buId, this.templateNum, sequenceNum).subscribe((response: any) =>{
            if (!response.hasError && response.length > 0) {
                 this.aboutUsContent = response;
                  this.aboutUsContent.forEach((cta: CmsContent) => {
                  cta.contentStructure = JSON.parse(cta.contentStructure);
                 });
                 this.aboutUsContent.sort((a, b) => b.contentNum - a.contentNum);
                  this.aboutUsContent.forEach((cta: any) => {
                    if (cta.contentName === CMSTemplateNames.Web_AboutUs + " 1" || cta.contentName == CMSTemplateNames. Mobile_AboutUs +" 1" ) {
                         this.aboutIntro = cta.contentStructure.recordList;
                    }else if (cta.contentName === CMSTemplateNames.Web_AboutUs + " 2" || cta.contentName == CMSTemplateNames. Mobile_AboutUs +" 2"){
                        this.aboutCommercial = cta.contentStructure.recordList;
                    } else if (cta.contentName === CMSTemplateNames.Web_AboutUs + " 3" || cta.contentName == CMSTemplateNames. Mobile_AboutUs +" 3"){
                        this.aboutConsumer = cta.contentStructure.recordList.filter(function(x){
                          return x.description !=""
                        });
                         this.aboutConsumerImages = cta.contentStructure.recordList.filter(function(x){
                          return x.description == "" && x.mediaUrl != ''
                          });
                        this.aboutConsumerTitle = cta.contentStructure.recordList.filter(function(x){
                          return x.description =="" && x.mediaUrl == "" && x.title != ''
                        });
                        
                        
                    }
                  });
                  
                  
            }
            
        })
  }
  

  navigateToTargetLink(cmsContentLinkObj: any) {
        if (!_.isEmpty(cmsContentLinkObj)) {
          window.open(cmsContentLinkObj.targetlink, '_self');
          
        }
  }
 
   
}